// extracted by mini-css-extract-plugin
export default {"container":"b8l30","header":"XPco-","showContent":"RBgds","noContent":"uI2dw","content":"xEzIg","skeleton-progress":"ppKz-"};